module.exports = __webpack_public_path__ + "img/21babdd.jpg";